// extracted by mini-css-extract-plugin
module.exports = {"root":"_2wahw","box":"_3XX9-","message":"_2bysg","button":"_37fm0"};